import { Link } from "react-router-dom";

import { getFemaleIcon, getMaleIcon } from "../services/icons";
import { getCountryByCode } from "../services/utils";
import { PetType } from "../types/pet";

const ageLabels = {
  puppy: "Puppy|0–1 year",
  young: "Young Adult|1–3 years",
  adult: "Adult|3–7 years",
  senior: "Senior|7–10+ years",
  geriatric: "Geriatric|10+ years",
};

const sizeLabels = {
  small: "Small|Up to 10 kg (22 lbs)",
  medium: "Medium|10–25 kg (22–55 lbs)",
  large: "Large|Over 25 kg (55 lbs)",
};

export default function DogCard({
  name,
  gender,
  image,
  breed,
  age,
  birthdate,
  size,
  transfer,
  shelter,
  country,
  id,
}: PetType) {
  const renderGenderIcon = () => {
    if (gender === "female") {
      return (
        <div className="rounded-[4px] bg-theme-amber-5 p-[4px] text-[12px] font-semibold leading-none text-theme-white">
          Female
        </div>
      );
    } else {
      return (
        <div className="rounded-[4px] bg-theme-purple-5 p-[4px] text-[12px] font-semibold leading-none text-theme-white">
          Male
        </div>
      );
    }
  };

  return (
    <div className="rounded-[6px] border-[1px] border-theme-grey-1 bg-theme-white p-[12px] transition hover:bg-theme-grey-0.25">
      <Link to={`/pet/${id}`} className="flex w-full flex-col gap-[10px]">
        <div className="relative aspect-[4/3] overflow-hidden rounded-[4px]">
          <img className="h-full w-full object-cover object-center" src={image} alt={name} />
          {/* <div className="absolute right-[5px] top-[5px]">
            <div className="flex flex-col items-end gap-1">
              <div>
                <div className="inline-block rounded-full bg-[rgba(0,0,0,.4)] p-[8px] text-[12px] font-semibold leading-none text-theme-white">
                  Disability
                </div>
              </div>
              <div>
                <div className="inline-block rounded-full bg-[rgba(0,0,0,.4)] p-[8px] text-[12px] font-semibold leading-none text-theme-white">
                  Neutered
                </div>
              </div>
            </div>
          </div> */}
        </div>
        <div className="flex">{renderGenderIcon()}</div>
        <div className="flex flex-col gap-[4px]">
          <div className="text-[16px] font-bold leading-tight text-theme-grey-11">{name}</div>
          <div className="text-[14px] font-semibold text-theme-grey-9.5">{breed}</div>
          <div className="text-[14px] text-theme-grey-9.5">
            {ageLabels[age]?.split("|")[0]}{" "}
            <span className="text-theme-grey-7">{ageLabels[age]?.split("|")[1]}</span>
          </div>
          <div className="text-[14px] text-theme-grey-9.5">
            {sizeLabels[size]?.split("|")[0]}{" "}
            <span className="text-theme-grey-7">{sizeLabels[size].split("|")[1]}</span>
          </div>
          <div className="flex flex-row items-center gap-[3px] text-[12px] font-semibold text-theme-grey-9.5">
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.09389 11.3931C5.24447 11.5893 5.39245 11.7821 5.53559 11.9712H5.54789C5.65583 12.1151 5.82577 12.2 6.00615 12.2C6.1865 12.2 6.35599 12.1151 6.46393 11.9712C6.60449 11.7858 6.74971 11.5968 6.89748 11.4044C8.3453 9.51958 10.038 7.31598 9.99935 5.13804C9.95342 2.88396 8.27236 1.20001 6 1.20001C3.72764 1.20001 2.04042 2.88408 2.00065 5.13804C1.96202 7.31183 3.64825 9.50921 5.09389 11.3931ZM6 7.20001C7.10457 7.20001 8 6.30458 8 5.20001C8 4.09544 7.10457 3.20001 6 3.20001C4.89543 3.20001 4 4.09544 4 5.20001C4 6.30458 4.89543 7.20001 6 7.20001Z"
                fill="#454340"
              />
            </svg>
            {getCountryByCode(country)}
          </div>
        </div>
      </Link>
    </div>
  );
}
